module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Suits_.84c53bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Suits_.jpg
// module id = OkWq
// module chunks = 0